import { render, staticRenderFns } from "./lotto-user-bet-detail.vue?vue&type=template&id=c002932c&"
import script from "./lotto-user-bet-detail.vue?vue&type=script&lang=js&"
export * from "./lotto-user-bet-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports